export default __webpack_public_path__ + "static/fs4-32219528a291e59ddd68b9c1acf88061.png";